import styled from 'styled-components'
import { mildGray, softGray } from '../../../styles/variables.js'

const List = styled.div`
  margin: 5px;
`
const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${softGray};
  margin-bottom: 8px;
  border-radius: 4px;
`

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  &.collapsed {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`

const ItemFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const Locales = styled.div`
  margin-left: 10px;
  flex: 1 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div {
    margin-right: 15px;
  }
`

const DeleteLink = styled.div`
  margin-right: 10px;
  margin-top: 34px;
  cursor: pointer;
  color: ${mildGray};
  transition: all .1s ease-in-out;
  flex: 0 0;
  max-height: 24px;
  font-size: 22px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
  &.collapsed {
    margin-top: 0px;
  }
`
const IconPlaceholder = styled.div`
  width: 24px;
`

const Collapse = styled.div`
  cursor: pointer;
  font-size: 16px;
  position: absolute;
  right: 20px;
  top: 5px;

  &.collapseUp {
      top: 0;
      &:hover: {
        opacity: 0.7;
      }
  }
`

const Title = styled.div`
  padding-right: 50px;
`

export default {
  List,
  Item,
  ItemContent,
  ItemFooter,
  DeleteLink,
  Locales,
  IconPlaceholder,
  Collapse,
  Title,
}
